<script lang="ts" setup>
definePageMeta({
  layout: 'home',
})

const news = [
  {
    time: '2025.03.25',
    title: '【FaW TOKYOご招待】仕入れコスト削減＆小ロット生産を現場でご案内！',
    img: 'https://static-jp.theckb.com/static-asset/xr/new4.png',
    id: '1'
  },
  {
    time: '2024.5.27',
    title: 'CEO呉氏、早稲田大学にて中国・日本間の越境EC市場を分析',
    img: 'https://static-jp.theckb.com/static-asset/xr/new1.png',
    id: '2'
  },
  {
    time: '2023.11.23',
    title: 'THE CKB × 1688 世界初の協力イベント開催',
    img: 'https://static-jp.theckb.com/static-asset/xr/new2.png',
    id: '3'
  },
  {
    time: '2023.10.11',
    title: 'SNIFF Group子会社「イト二フ」、盛大に開業',
    img: 'https://static-jp.theckb.com/static-asset/xr/new3.png',
    id: '4'
  }
]

</script>

<template>
  <div>
    <XrHeader />
    <XrCrumb :list="[{ label: 'ニュース' }]" />
    <ADevice>
      <template #h5>
        <div class="text-[32px] leading-[40px] px-[32px] pt-[40px] font-black !text-black/85 text-center">ニュース</div>
        <div class="px-[12px] pt-[16px] flex flex-col">
          <ALink :to="`/news/${item.id}`" v-for="(item, idx) in news" :key="item.id"
            class="pb-[16px]  border-b border-black/5 mb-[16px]" :class="{ 'border-none': news.length - 1 === idx }">
            <ElImage class="w-full" :src="item.img" />
            <div class="text-[12px] leading-[20px] mt-[16px] text-black/85">
              <span class="mr-[16px]">{{ item.time }} </span>
              イベント
            </div>
            <div class="text-[16px] leading-[24px] text-black/85 mt-[8px]">
              {{ item.title }}
            </div>
          </ALink>
        </div>
      </template>
      <template #pc>
        <div class="w-[1120px] mx-auto py-[48px]">
          <div class="text-[48px] leading-[56px] text-center font-black text-black/85">ニュース</div>
          <div class="mt-[48px]">
            <ALink :to="`/news/${item.id}`" v-for="item in news" :key="item.id" class="flex mb-[32px]">
              <div class="w-[192px] text-[12px] leading-[20px] text text-black/85">{{ item.time }}</div>
              <div class="w-[640px] text-black/85">
                <div class="text-[24px] leading-[32px] font-normal mb-[24px] ">{{ item.title }}</div>
                <ALink :to="`/news/${item.id}`" class="text-[14px] leading-[22px] mt-[24px] !text-black/85 ">イベント
                </ALink>
              </div>
              <ElImage class="w-[256px] h-[144px] ml-[32px]" :src="item.img" alt="" />
            </ALink>
          </div>
        </div>
      </template>
    </ADevice>
    <XrFooter />
  </div>
</template>

<style lang="less" scoped></style>
